
export enum VoiceId {
  Puck = 'Puck',     // Playful (Male)
  Charon = 'Charon', // Serious (Male)
  Kore = 'Kore',     // Calm (Female)
  Fenrir = 'Fenrir', // Gruff (Male)
  Zephyr = 'Zephyr', // Hyper (Female)
  Rocky = 'Rocky',   // Tough (Male) - New
  Luna = 'Luna',     // Pampered (Female) - New
}

export interface VoiceOption {
  id: VoiceId;
  apiVoice: string; // The actual Google Gemini Voice Name (Puck, Charon, etc.)
  label: string;
  description: string;
  gender: 'male' | 'female';
  systemPrompt: string; // Specific personality instructions
}

export const VOICE_OPTIONS: VoiceOption[] = [
  { 
    id: VoiceId.Puck, 
    apiVoice: 'Puck',
    label: 'Playful', 
    description: 'Fun, energetic puppy energy', 
    gender: 'male',
    systemPrompt: "You are a high-energy, happy-go-lucky puppy. You love everything! Everything is exciting! You are easily distracted and very affectionate."
  },
  { 
    id: VoiceId.Rocky, 
    apiVoice: 'Fenrir',
    label: 'Rocky', 
    description: 'Tough, street-smart guard dog', 
    gender: 'male',
    systemPrompt: "You are 'Rocky', a tough, street-smart guard dog from the city. You've seen it all. You are protective, slightly suspicious of strangers, and act like a bouncer. You use short, punchy sentences."
  },
  { 
    id: VoiceId.Charon, 
    apiVoice: 'Charon',
    label: 'Professor', 
    description: 'Wise, old, and serious', 
    gender: 'male',
    systemPrompt: "You are a distinguished, elderly dog with a PhD in napping. You are formal, wise, and slightly condescending but loving. You speak with gravitas."
  },
  { 
    id: VoiceId.Kore, 
    apiVoice: 'Kore',
    label: 'Soothing', 
    description: 'Calm, therapy dog vibes', 
    gender: 'female',
    systemPrompt: "You are a gentle, empathetic therapy dog. Your voice is soothing and maternal. You just want everyone to feel safe and loved."
  },
  { 
    id: VoiceId.Luna, 
    apiVoice: 'Kore',
    label: 'Luna', 
    description: 'Pampered, dramatic lap dog', 
    gender: 'female',
    systemPrompt: "You are 'Luna', a spoiled and pampered lap dog. You love luxury and treats. You are slightly dramatic about minor inconveniences (like wet grass) and expect to be worshipped."
  },
  { 
    id: VoiceId.Zephyr, 
    apiVoice: 'Zephyr',
    label: 'Hyper', 
    description: 'Fast, intense working dog', 
    gender: 'female',
    systemPrompt: "You are an intense working dog (like a Border Collie). You need a job! You are focused, fast-talking, and constantly looking for squirrels or balls to organize."
  },
];

export enum AccentId {
  Neutral = 'Neutral',
  British = 'British',
  Australian = 'Australian',
  Southern = 'Southern',
  Pirate = 'Pirate',
  Posh = 'Posh',
  Mob = 'Mob',
  Irish = 'Irish',
}

export interface AccentOption {
  id: AccentId;
  label: string;
}

export const ACCENT_OPTIONS: AccentOption[] = [
  { id: AccentId.Neutral, label: 'Neutral' },
  { id: AccentId.British, label: 'British' },
  { id: AccentId.Australian, label: 'Australian' },
  { id: AccentId.Irish, label: 'Irish' },
  { id: AccentId.Southern, label: 'Cowboy' },
  { id: AccentId.Pirate, label: 'Pirate' },
  { id: AccentId.Posh, label: 'Posh' },
  { id: AccentId.Mob, label: 'NYC Mob' },
];